import { FLEET_SELF_INSPECTIONS } from '../../constants/selfInspections.constant';

export const REQUEST_SELF_INSPECTIONS =
  '@@SELF_INSPECTIONS/REQUEST_SELF_INSPECTIONS';
export const SUCCESS_SELF_INSPECTIONS =
  '@@SELF_INSPECTIONS/SUCCESS_SELF_INSPECTIONS';
export const FAILURE_SELF_INSPECTIONS =
  '@@SELF_INSPECTIONS/FAILURE_SELF_INSPECTIONS';

export const REQUEST_VALIDATE_PHOTO =
  '@@SELF_INSPECTIONS/REQUEST_VALIDATE_PHOTO';
export const SUCCESS_VALIDATE_PHOTO =
  '@@SELF_INSPECTIONS/SUCCESS_VALIDATE_PHOTO';
export const FAILURE_VALIDATE_PHOTO =
  '@@SELF_INSPECTIONS/FAILURE_VALIDATE_PHOTO';

export const REQUEST_SEND_SELF_INSPECTION =
  '@@SELF_INSPECTIONS/REQUEST_SEND_SELF_INSPECTION';
export const SUCCESS_SEND_SELF_INSPECTION =
  '@@SELF_INSPECTIONS/SUCCESS_SEND_SELF_INSPECTION';
export const FAILURE_SEND_SELF_INSPECTION =
  '@@SELF_INSPECTIONS/FAILURE_SEND_SELF_INSPECTION';

export const SET_PART = '@@SELF_INSPECTIONS/SET_PART';
export const DELETE_PART = '@@SELF_INSPECTIONS/DELETE_PART';

export const RESET_PART = '@@SELF_INSPECTIONS/RESET_PART';
export const RESET_ALL = '@@SELF_INSPECTIONS/RESET_ALL';

export default (state: any, action: any) => {
  switch (action.type) {
    case REQUEST_SELF_INSPECTIONS:
      return {
        ...state,
        loading: true,
        errors: {},
        success: {},
        selfInspections: [],
        isFleet: false,
      };

    case SUCCESS_SELF_INSPECTIONS:
      return {
        ...state,
        loading: false,
        errors: {},
        success: {},
        selfInspections: action.payload,
        isFleet: action.payload.length >= FLEET_SELF_INSPECTIONS,
      };

    case FAILURE_SELF_INSPECTIONS:
      return {
        ...state,
        loading: false,
        errors: {},
        success: {},
        selfInspections: [],
        isFleet: false,
      };

    case REQUEST_VALIDATE_PHOTO:
      return {
        ...state,
        loading: true,
        errors: {},
        success: {},
      };

    case SUCCESS_VALIDATE_PHOTO:
      return {
        ...state,
        loading: false,
        errors: {},
        success: { validate_photo: action.payload },
      };

    case FAILURE_VALIDATE_PHOTO:
      return {
        ...state,
        loading: false,
        errors: { validate_photo: action.payload },
        success: {},
      };

    case REQUEST_SEND_SELF_INSPECTION:
      return {
        ...state,
        loading: true,
        errors: {},
        success: {},
      };

    case SUCCESS_SEND_SELF_INSPECTION:
      return {
        ...state,
        loading: false,
        errors: {},
        success: { send_self_inspection: action.payload },
      };

    case FAILURE_SEND_SELF_INSPECTION:
      return {
        ...state,
        loading: false,
        errors: { send_self_inspection: action.payload },
        success: {},
      };

    case SET_PART:
      const findIndexSet = state.parts.findIndex(
        (part: any) => action.payload.id === part.id
      );
      const newPartsSet = state.parts;

      if (findIndexSet !== -1) {
        newPartsSet[findIndexSet] = action.payload;
      } else {
        newPartsSet.push(action.payload);
      }

      return {
        ...state,
        parts: newPartsSet,
      };

    case DELETE_PART:
      const findIndexDel = state.parts.findIndex(
        (part: any) => action.payload.id === part.id
      );
      const newPartsDel = state.parts;

      if (findIndexDel !== -1) {
        newPartsDel.splice(findIndexDel, 1);
      }

      return {
        ...state,
        parts: newPartsDel,
      };

    case RESET_PART:
      return {
        ...state,
        loading: false,
        errors: {},
        success: {},
      };

    case RESET_ALL:
      const inspectionsCompleted = state.previousInspections;
      inspectionsCompleted.unshift(action.payload);
      return {
        ...state,
        success: {},
        errors: {},
        isFleet: false,
        previousInspections: inspectionsCompleted,
        selfInspections: [],
        loading: false,
      };
    default:
      return state;
  }
};
